/* global window */
/* global */

import { adStatus } from 'Constants/adStatus';
import { compressData } from './compression';
import { PLATFORM } from 'Constants/device.APP_TARGET';
import { fetchWithRetry } from './api';

export const __TRACK_SELECT_FROM_STORAGE_NAME = 'trackSelectFrom';
/** Return an object with commons params to track in seller actions
  * @param {object} itemStatus:
  * {
  *     @param {string} status
  *     @param {bool} allow_edit
  * }
  * @param {string} origin
  * @param {string} flowType
  */
export const getMyAdTrackInfo = (itemStatus, params) => {
    const { status, allow_edit } = itemStatus;
    let trackStatus = status;

    if (status === adStatus.MODERATED) {
        trackStatus = allow_edit ? 'moderated_soft' : 'moderated_hard';
    }

    return itemStatus ? {
        item_status: trackStatus,
        ...params
    } : {};
};

const getItemStatus = item => {
    let status = 'normal';

    if (item.hot) {
        status = 'hot';
    }
    else if (item.new) {
        status = 'new';
    }
    return status;
};

export const getFavouriteItemInfo = item => {
    return item ? {
        item_id: item.id,
        seller_id: item.user_id,
        item_status: getItemStatus(item.status.flags),
        images_count: item.images.length,
        creation_date: item.created_at,
        category_id: item.category_id,
        price: (item.price && item.price.value) ? item.price.value.raw : ''
    } : {};
};

/**
 * https://github.com/GoogleChromeLabs/first-input-delay/blob/master/dist/first-input-delay.min.js
 */
export const getFirstInputDelayTrackingHeader = () => {
    return `
    <script type="text/javascript">
        !function(n,e){var t,o,i,c=[],f={passive:!0,capture:!0},r=new Date,a="pointerup",u="pointercancel";function p(n,c){t||(t=c,o=n,i=new Date,w(e),s())}function s(){o>=0&&o<i-r&&(c.forEach(function(n){n(o,t)}),c=[])}function l(t){if(t.cancelable){var o=(t.timeStamp>1e12?new Date:performance.now())-t.timeStamp;"pointerdown"==t.type?function(t,o){function i(){p(t,o),r()}function c(){r()}function r(){e(a,i,f),e(u,c,f)}n(a,i,f),n(u,c,f)}(o,t):p(o,t)}}function w(n){["click","mousedown","keydown","touchstart","pointerdown"].forEach(function(e){n(e,l,f)})}w(n),self.perfMetrics=self.perfMetrics||{},self.perfMetrics.onFirstInputDelay=function(n){c.push(n),s()}}(addEventListener,removeEventListener);

        perfMetrics.onFirstInputDelay(function(delay, event) {
            window.fid = {
                delay: delay,
                event: event
            }
        });
    </script>
`;
};

export const setSelectFrom = origin => {
    switch (origin) {
        case 'browser':
        case 'search':
            return 'resultpage';
        case 'olx_autos_home':
            return 'landing_buy';
        default:
            return origin;
    }
};

export const getExponeaJSLibrary = exponeaConfig => {
    if (exponeaConfig && exponeaConfig.enabled) {
        return `
            <script type="text/javascript" async>
                !function(e,n,t,i,o,r){function a(e){if("number"!=typeof e)return e;var n=new Date;return new Date(n.getTime()+1e3*e)}var c=4e3,s="xnpe_async_hide";function p(e){return e.reduce((function(e,n){return e[n]=function(){e._.push([n.toString(),arguments])},e}),{_:[]})}function m(e,n,t){var i=t.createElement(n);i.src=e;var o=t.getElementsByTagName(n)[0];return o.parentNode.insertBefore(i,o),i}function u(e){return"[object Date]"===Object.prototype.toString.call(e)}r.target=r.target||"https://api.exponea.com",r.file_path=r.file_path||r.target+"/js/exponea.min.js",o[n]=p(["anonymize","initialize","identify","getSegments","update","track","trackLink","trackEnhancedEcommerce","getHtml","showHtml","showBanner","showWebLayer","ping","getAbTest","loadDependency","getRecommendation","reloadWebLayers","_preInitialize"]),o[n].notifications=p(["isAvailable","isSubscribed","subscribe","unsubscribe"]),o[n]["snippetVersion"]="v2.5.0",function(e,n,t){e[n]["_"+t]={},e[n]["_"+t].nowFn=Date.now,e[n]["_"+t].snippetStartTime=e[n]["_"+t].nowFn()}(o,n,"performance"),function(e,n,t,i,o,r){e[o]={sdk:e[i],sdkObjectName:i,skipExperiments:!!t.new_experiments,sign:t.token+"/"+(r.exec(n.cookie)||["","new"])[1],path:t.target}}(o,e,r,n,i,RegExp("__exponea_etc__"+"=([\\w-]+)")),function(e,n,t){m(e.file_path,n,t)}(r,t,e),function(e,n,t,i,o,r,p){if(e.new_experiments){!0===e.new_experiments&&(e.new_experiments={});var l,f=e.new_experiments.hide_class||s,_=e.new_experiments.timeout||c,d=encodeURIComponent(r.location.href.split("#")[0]);e.cookies&&e.cookies.expires&&("number"==typeof e.cookies.expires||u(e.cookies.expires)?l=a(e.cookies.expires):e.cookies.expires.tracking&&("number"==typeof e.cookies.expires.tracking||u(e.cookies.expires.tracking))&&(l=a(e.cookies.expires.tracking))),l&&l<new Date&&(l=void 0);var x=e.target+"/webxp/"+n+"/"+r[t].sign+"/modifications.min.js?http-referer="+d+"&timeout="+_+"ms"+(l?"&cookie-expires="+Math.floor(l.getTime()/1e3):"");"sync"===e.new_experiments.mode&&r.localStorage.getItem("__exponea__sync_modifications__")?function(e,n,t,i,o){t[o][n]="<"+n+' src="'+e+'"></'+n+">",i.writeln(t[o][n]),i.writeln("<"+n+">!"+o+".init && document.writeln("+o+"."+n+'.replace("/'+n+'/", "/'+n+'-async/").replace("><", " async><"))</'+n+">")}(x,n,r,p,t):function(e,n,t,i,o,r,a,c){r.documentElement.classList.add(e);var s=m(t,i,r);function p(){o[c].init||m(t.replace("/"+i+"/","/"+i+"-async/"),i,r)}function u(){r.documentElement.classList.remove(e)}s.onload=p,s.onerror=p,o.setTimeout(u,n),o[a]._revealPage=u}(f,_,x,n,r,p,o,t)}}(r,t,i,0,n,o,e),function(e,n,t){var i;(null===(i=t.experimental)||void 0===i?void 0:i.non_personalized_weblayers)&&e[n]._preInitialize(t),e[n].start=function(i){i&&Object.keys(i).forEach((function(e){return t[e]=i[e]})),e[n].initialize(t)}}(o,n,r)}(document,"exponea","script","webxpClient",window,{
                    target: "https://fcg-api.exponea.com",
                    token: "${ exponeaConfig.token }",
                });
                exponea.start({ ping: { properties:{ sending_system:'Panamera - frontend' }} });
            </script>
        `;
    }
    return '';
};

export const verifyRedirectionParameters = query => {
    const {
        redirection_source = null,
        redirection_medium = null,
        redirection_campaign = null,
        redirection_session_id = null,
        redirection_userid = null
    } = query || {};

    if (redirection_source || redirection_medium || redirection_campaign) {
        return {
            redirection_source,
            redirection_medium,
            redirection_campaign,
            redirection_session_id,
            redirection_userid
        };
    }
    return {};
};

export const cleanUpDataLayer = () => {
    try {
        let cleanupNeeded = true;

        window.dataLayer = window.dataLayer || [];
        // Continue cleanup until no more elements meet the conditions
        while (cleanupNeeded) {
            cleanupNeeded = false; // Reset the cleanup flag

            for (let index = 0; index < window.dataLayer.length; index += 1) {
                const dataObject = window.dataLayer[index];

                // Conditions for removing an element
                const shouldRemove = (
                    (dataObject.event === undefined || (dataObject.event.slice(0, 4) !== 'gtm.' && dataObject.event.slice(0, 10) !== 'clevertap_') && dataObject['gtm.uniqueEventId'] !== undefined) // eslint-disable-line no-magic-numbers
                    && typeof dataObject === 'object'
                    && dataObject.call === undefined
                    && dataObject.dynx_itemid === undefined
                    && dataObject.dynx_totalvalue === undefined
                    && dataObject.dynx_pagetype === undefined
                );

                if (shouldRemove) {
                    // Remove the element and trigger cleanup again
                    window.dataLayer.splice(index, 1);
                    cleanupNeeded = true;
                    break; // Exit the loop to start cleanup again
                }
            }
        }
    }
    catch (error) {
        // Catch and track errors
        console.error(error); // eslint-disable-line
    }
};

export const filterEventData = (eventData, config) => {
    if (
        !eventData
      || typeof eventData !== 'object'
      || (!Array.isArray(eventData.trackEvent) && !eventData?.trackPage)
    ) {
        return null;
    }

    if (
        !config
      || typeof config !== 'object'
      || !Array.isArray(config.whitelisted_events)
      || !Array.isArray(config.whitelisted_properties)
    ) {
        return null;
    }

    const eventName = eventData?.trackEvent?.[0] || eventData?.trackPage;

    if (!eventName || !config.whitelisted_events.includes(eventName)) {
        return null;
    }

    const filteredData = {};

    for (const key in eventData) {
        if (config.whitelisted_properties.includes(key)) {
            filteredData[key] = eventData[key];
        }
    }

    return filteredData;
};

export const eventHouseDataTransformation = (data, filteredData, eventName, userData, sdkVersion, sessionId) => {
    const timestamp = data.ts || Date.now();

    const transformedData = {
        event_name: eventName,
        timestamp,
        session_params: {
            session_id: sessionId
        },
        platform: {
            name: data?.platform_type,
            app_version: data?.app_version,
            device_fingerprint: data?.device_fingerprint,
            sdk_version: sdkVersion
        },
        user_params: {
            user_id: data?.user_id,
            name: data?.user_name,
            email: userData?.email,
            phone: userData?.phone,
            user_status: data?.user_status,
            is_paid: !!userData?.premium_user,
            ip: data?.ip_address,
            lat: data?.lat,
            ['long']: data?.long
        },
        event_params: { ...filteredData }
    };

    return transformedData;
};

export const sendEventDataToEventHouse = (data, eventHouseConfig, config, userData, sessionId, logTracking) => {
    const eventData = filterEventData(data, config);

    if (eventData) {
        const transformedData = eventHouseDataTransformation(data, eventData, (data?.trackEvent?.[0] || data.trackPage), userData, eventHouseConfig?.sdk_version, sessionId);

        const eventHouseURL = `${eventHouseConfig?.url}/api/events`;
        const compressedData = compressData([transformedData], { level: 1 });

        fetchWithRetry(eventHouseURL, {
            method: 'POST',
            headers: {
                'Content-Encoding': 'gzip',
                'Content-Type': 'application/json',
                'X-Panamera-Client-Id': `web-${PLATFORM}`
            },
            body: compressedData
        }, eventHouseConfig.retries, eventHouseConfig.interval).then(() => logTracking('eventHouse', {
            ...transformedData
        })
        );
    }
};
